import React from 'react';
import pt from 'prop-types';
import classNames from 'classnames';

const STEPS = Object.freeze([
  { id: 'details', label: 'Details' },
  { id: 'expertise', label: 'Expertise' },
  { id: 'account', label: 'Account' },
]);

export default function SignupStepper({ step, onGoToStep, canGoBack = true }) {
  const currentIndex = STEPS.findIndex((item) => item.id === step);

  return (
    <div className="signup-stepper">
      {STEPS.map((item, index) => {
        const isComplete = index < currentIndex;
        const isCurrent = index === currentIndex;
        const className = classNames('signup-stepper_step', {
          complete: isComplete,
          current: isCurrent,
        });

        return (
          <React.Fragment key={item.id}>
            {index > 0 && (
              <span className="signup-stepper_separator">&gt;</span>
            )}
            {isComplete && canGoBack ? (
              <button
                type="button"
                className={className}
                onClick={() => onGoToStep(item.id)}
              >
                {item.label}
              </button>
            ) : (
              // A label, not a disabled control: `button:disabled` carries a
              // global `!important` colour that would outrank the step's own
              <span
                className={className}
                aria-current={isCurrent ? 'step' : undefined}
              >
                {item.label}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}

SignupStepper.propTypes = {
  step: pt.oneOf(STEPS.map((item) => item.id)).isRequired,
  onGoToStep: pt.func.isRequired,
  canGoBack: pt.bool,
};

export { STEPS };
